import React from 'react';
import { Provider } from 'react-redux';
import { IntlProvider } from 'common/components/Intl';
import { configureLocales } from 'common/locales';

import store from '../store';

configureLocales(global.translations.locale);

export default class WrappedBase extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <IntlProvider
          locale={global.translations.locale}
          messages={global.translations.messages}
        >
          {this.props.children}
        </IntlProvider>
      </Provider>
    );
  }
}
